import { render, staticRenderFns } from "./OnlineMsg.vue?vue&type=template&id=d53b71b4&scoped=true&"
import script from "./OnlineMsg.vue?vue&type=script&lang=js&"
export * from "./OnlineMsg.vue?vue&type=script&lang=js&"
import style0 from "./OnlineMsg.vue?vue&type=style&index=0&id=d53b71b4&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53b71b4",
  null
  
)

export default component.exports